import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Building, Briefcase, MoreHorizontal } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { lendingPartners } from '../mock';

const LendingPartners = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Page Header */}
      <section className="pt-24 pb-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-blue-50/30">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 text-center">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#DC143C] mb-4">
              Our Lending Partners
            </h1>
            <p className="text-base text-gray-600">
              We collaborate with India's leading financial institutions to bring you the best loan solutions
            </p>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-6xl space-y-16">
          
          {/* Banks */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-[#DC143C] rounded-lg flex items-center justify-center">
                <Building className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900">Banks</h2>
                <p className="text-gray-600">Leading public and private sector banks</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {lendingPartners.banks.map((partner) => (
                <Card key={partner.id} className="hover:shadow-lg transition-shadow duration-300 border-2 border-gray-200 hover:border-[#DC143C]">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-semibold text-gray-900">{partner.name}</h3>
                      <Badge className="bg-red-50 text-[#DC143C] hover:bg-red-100">Bank</Badge>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* NBFCs */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-[#2C3E50] rounded-lg flex items-center justify-center">
                <Briefcase className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900">NBFCs</h2>
                <p className="text-gray-600">Non-Banking Financial Companies</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {lendingPartners.nbfcs.map((partner) => (
                <Card key={partner.id} className="hover:shadow-lg transition-shadow duration-300 border-2 border-gray-200 hover:border-[#2C3E50]">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-semibold text-gray-900">{partner.name}</h3>
                      <Badge className="bg-blue-50 text-[#2C3E50] hover:bg-blue-100">NBFC</Badge>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Others */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                <MoreHorizontal className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900">Others</h2>
                <p className="text-gray-600">Housing finance companies and specialized lenders</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {lendingPartners.others.map((partner) => (
                <Card key={partner.id} className="hover:shadow-lg transition-shadow duration-300 border-2 border-gray-200 hover:border-green-600">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-semibold text-gray-900">{partner.name}</h3>
                      <Badge className="bg-green-50 text-green-700 hover:bg-green-100">Other</Badge>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#2C3E50] to-[#3d5568]">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Want to Partner with Us?
          </h2>
          <p className="text-lg text-gray-200 mb-6 max-w-2xl mx-auto">
            We're always looking to expand our network with reliable financial institutions
          </p>
          <a href="mailto:partnerships@capitaliq.com" className="inline-block bg-[#DC143C] hover:bg-[#B8112A] text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-300">
            Get in Touch
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LendingPartners;